// import React, { useEffect, useState } from "react";
// import styles from "./ManageProductionLine.module.css";
// import { useAuth } from "../../components/context/Auth";
// import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import { TestTopAddDealerIcon } from "../../components/icons/Icon";
// import DealerStatusCard from "../../components/updatedComponents/Dealers/DealerStatusCard";
// import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
// import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
// import { TemplateNotFound } from "../../components/icons/Icon2";
// import GoToPage from "../../components/updatedComponents/Pagnation/GoToPage";
// import Pagenation from "../../components/updatedComponents/Pagnation/Pagenation";
// import ProdLineInfoCard from "../../components/updatedComponents/Production/ManageProduction/ProdLineInfoCard";
// import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
// import fetchData from "../../APIsControll/apiControll";
// import { ItemChipSearch } from "../../components/updatedComponents/Production/ManageProduction/ItemChipSearch";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import { SkeletonCard } from "../../components/updatedComponents/Production/ManageProduction/SkeletonCard";
// import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
// import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";

// const STATUS_FILTERS = ["All", "Running", "Maintenance", "Stopped"];

// const EMPTY_FORM = {
//   name: "",
//   pLId: "",
//   modelNo: "",
//   warehouse: "",
//   warehouseId: "",
//   capacity: "",
//   workingHrs: "",
//   status: "Stopped",
//   autoAssignProduct: false,
// };

// const ManageProductionLine = () => {
//   const { mode, managerId, designations } = useAuth();
//   const { show } = useToast();

//   const [Isstatus, setIsstatus] = useState("All");
//   const [search, setSearch] = useState("");
//   const [debouncedSearch, setDebouncedSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [showDrawer, setShowDrawer] = useState(false);
//   const [selectedLine, setSelectedLine] = useState(null);
//   const [form, setForm] = useState(EMPTY_FORM);
//   const [warehouses, setWarehouses] = useState([]);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [selectedWarehouse, setSelectedWarehouse] = useState("All");
//   const [lines, setLines] = useState([]);
//   const [statusCounts, setStatusCounts] = useState([]);
//   const [drawerLoading, setDrawerLoading] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState(null);
//   const isSuperAdmin = designations.includes("superadmin");
//   const openEdit = async (line) => {
//     setSelectedLine(line);
//     setShowDrawer(true);
//     setDrawerLoading(true);

//     try {
//       const payload = {
//         managerId: managerId,
//         pLId: line.pLId,
//       };
//       const res = await fetchData(`production/productionLine`, payload);

//       if (res?.status === "success" && res.data) {
//         const m = res.data;

//         setSelectedItems(
//           (m.items || []).map((i) => ({
//             itemNo: i.itemNo,
//             warehouseId: m.warehouseId,
//           })),
//         );

//         setForm({
//           name: m.name,
//           pLId: m.pLId || "",
//           modelNo: m.modelNumber || "",
//           warehouse: m.warehouseId,
//           capacity: m.capacity,
//           workingHrs: m.workingHrs,
//           status: m.status ? m.status : "Stopped",
//           autoAssignProduct: m.autoAssignProduct,
//         });

//         setSelectedLine((prev) => ({ ...prev, ...m }));
//       } else {
//         show(res?.msg || "Failed to load machine details", "error");
//         setShowDrawer(false);
//       }
//     } catch (error) {
//       show("Failed to load machine details", "error");
//       setShowDrawer(false);
//     } finally {
//       setDrawerLoading(false);
//     }
//   };
//   const handleDeleteLine = async (line) => {
//     try {
//       const payload = { managerId, pLId: line.pLId };
//       const result = await fetchData(`production/delproductionLine`, payload);
//       if (result?.status === "success") {
//         show(result?.msg || "Deleted");
//         fetchLines();
//       } else {
//         show(result?.msg, "error");
//       }
//     } catch (error) {}
//   };

//   useEffect(() => {
//     const getAllwarehouses = async () => {
//       try {
//         const payload = { managerId };
//         const AllWarehouse = await fetchData(
//           `warehouses/getAllWarehouseList`,
//           payload,
//         );
//         setWarehouses(
//           AllWarehouse.data.map((w) => ({
//             label: w.warehousename,
//             value: w.warehouseId,
//           })),
//         );
//       } catch (error) {}
//     };
//     getAllwarehouses();
//   }, [managerId]);

//   // Debounce free-text search so we don't hit the API on every keystroke
//   useEffect(() => {
//     const t = setTimeout(() => setDebouncedSearch(search), 400);
//     return () => clearTimeout(t);
//   }, [search]);

//   // Reset to page 1 whenever a filter changes (status / warehouse / search)
//   useEffect(() => {
//     setPage(1);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [Isstatus, selectedWarehouse, debouncedSearch]);

//   const fetchLines = async () => {
//     setLoading(true);
//     try {
//       const payload = {
//         managerId: managerId,
//         status: Isstatus === "All" ? "" : Isstatus,
//         warehouseId: selectedWarehouse === "All" ? "" : selectedWarehouse,
//         keyword: debouncedSearch,
//       };
//       const res = await fetchData(
//         `production/productionLines?page=${page}`,
//         payload,
//       );

//       if (res?.status === "success") {
//         setLines(
//           (res.data || []).map((m) => ({
//             id: m.pLId,
//             pLId: m.pLId,
//             name: m.name,
//             modelNumber: m.modelNumber || "",
//             warehouse: m.warehouse,
//             warehouseId: m.warehouseId,
//             capacity: m.capacity,
//             workingHrs: m.workingHrs,
//             status: m.status || "",
//             items: m.items || [],
//             createdAt: m.createdAt,
//           })),
//         );
//         setStatusCounts(res.prodLines || []);
//         setTotalPages(res.pages || 1);
//       } else {
//         setLines([]);
//         setStatusCounts([]);
//         setTotalPages(1);
//       }
//     } catch (error) {
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLines();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [managerId, page, Isstatus, selectedWarehouse, debouncedSearch]);

//   const lineStatusData = STATUS_FILTERS.map((s) => {
//     const match = statusCounts.find(
//       (c) => c.status?.toLowerCase() === s.toLowerCase(),
//     );
//     return {
//       statusText: s,
//       statusItemCount: match ? match.count : 0,
//     };
//   });

//   const openCreate = () => {
//     setSelectedLine(null);
//     setForm(EMPTY_FORM);
//     setSelectedItems([]);
//     setShowDrawer(true);
//   };

//   const handleFormChange = (field, value) =>
//     setForm((prev) => ({ ...prev, [field]: value }));
//   const handleStatusChange = (s) => {
//     setIsstatus(s);
//     setPage(1);
//   };
//   const handleAddItem = (item) => {
//     setSelectedItems((prev) => {
//       const exists = prev.some(
//         (p) => p.itemNo === item.itemNo && p.warehouseId === item.warehouseId,
//       );

//       if (exists) return prev;

//       return [...prev, item];
//     });
//   };
//   const handleRemoveItem = (item) =>
//     setSelectedItems((prev) =>
//       prev.filter(
//         (i) =>
//           !(i.itemNo === item.itemNo && i.warehouseId === item.warehouseId),
//       ),
//     );

//   const handleCreate = async () => {
//     try {
//       const payload = {
//         managerId: managerId,
//         name: form.name,
//         modelNumber: form.modelNo,
//         status: form.status,
//         capacity: Number(form.capacity),
//         workingHrs: Number(form.workingHrs),
//         warehouse:
//           warehouses.find((w) => w.value === form.warehouse)?.label || "",
//         warehouseId: form.warehouse,
//         selectedItems: selectedItems.map((i) => ({
//           itemNo: i.itemNo,
//         })),
//         autoAssignProduct: form.autoAssignProduct,
//       };
//       const result = await fetchData(`production/addUpProductionLine`, payload);

//       if (result.status === "success") {
//         setShowDrawer(false);
//         show(result?.msg);
//         setForm(EMPTY_FORM);
//         setSelectedItems([]);
//         fetchLines();
//       } else {
//         show(result?.msg, "error");
//       }
//     } catch (error) {}
//   };

//   const handleUpdate = async () => {
//     try {
//       const payload = {
//         managerId: managerId,
//         pLId: selectedLine?.pLId,
//         name: form.name,
//         modelNumber: form.modelNo,
//         status: form.status,
//         capacity: Number(form.capacity),
//         workingHrs: Number(form.workingHrs),
//         warehouse:
//           warehouses.find((w) => w.value === form.warehouse)?.label || "",
//         warehouseId: form.warehouse,
//         selectedItems: selectedItems.map((i) => ({
//           itemNo: i.itemNo,
//         })),
//         autoAssignProduct: form.autoAssignProduct,
//       };
//       const result = await fetchData(`production/addUpProductionLine`, payload);

//       if (result.status === "success") {
//         setShowDrawer(false);
//         show(result?.msg);
//         setForm(EMPTY_FORM);
//         setSelectedItems([]);
//         fetchLines();
//       } else {
//         show(result?.msg, "error");
//       }
//     } catch (error) {}
//   };

//   const handleOpenModal = (content) => {
//     setModalContent(content);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setModalContent(null);
//   };

//   const validateForm = () => {
//     if (!form.name.trim()) {
//       show("Production Line Name is required.", "error");
//       return false;
//     }

//     if (!form.warehouse) {
//       show("Please select a warehouse.", "error");
//       return false;
//     }

//     if (!form.modelNo.trim()) {
//       show("Model No is required.", "error");
//       return false;
//     }

//     if (!form.capacity) {
//       show("Capacity is required.", "error");
//       return false;
//     }

//     if (!form.workingHrs) {
//       show("Working Hours is required.", "error");
//       return false;
//     }

//     if (!form.status) {
//       show("Status is required.", "error");
//       return false;
//     }

//     if (selectedItems.length === 0) {
//       show("Please select at least one item.", "error");
//       return false;
//     }

//     return true;
//   };

//   const handleShowModalContent = (line, text) => {
//     if (text === "create" || text === "update") {
//       if (!validateForm()) return;
//     }
//     handleOpenModal(
//       <ManagerModal
//         heading={`${text.charAt(0).toUpperCase() + text.slice(1)} Production Line`}
//         centerHeading={`Are you sure you want to ${text} Production Line`}
//         subHeading={`To confirm, type ${text}`}
//         targetWord={text}
//         handleSubmit={
//           text === "update"
//             ? () => handleUpdate()
//             : text === "delete"
//               ? () => handleDeleteLine(line)
//               : () => handleCreate()
//         }
//         handleCloseModal={() => setIsModalOpen(false)}
//         focus={true}
//       />,
//     );
//   };
//   return (
//     <>
//       {/* ── Centered Modal ──────────────────────────────────── */}
//       {showDrawer && (
//         <div
//           className={styles.modalOverlay}
//           onClick={() => setShowDrawer(false)}
//         >
//           <div
//             className={`${styles.centeredModal} ${mode ? styles.centeredModalDark : ""}`}
//             onClick={(e) => e.stopPropagation()}
//           >
//             {/* Header */}
//             <div className={styles.drawerHeader}>
//               <h2>
//                 {selectedLine
//                   ? "Update Production Line"
//                   : "Add Production Line"}
//               </h2>
//               <button onClick={() => setShowDrawer(false)}>✕</button>
//             </div>

//             {/* Body */}
//             {drawerLoading ? (
//               <div style={{ padding: "40px", textAlign: "center" }}>
//                 Loading...
//               </div>
//             ) : (
//               <div className={styles.drawerBody}>
//                 <div className={styles.formRow}>
//                   <div className={styles.formGroup}>
//                     <label className={mode ? styles.labelDark : ""}>
//                       Production Line Name
//                     </label>
//                     <input
//                       type="text"
//                       value={form.name}
//                       onChange={(e) => handleFormChange("name", e.target.value)}
//                       placeholder="Enter line name"
//                       className={mode ? styles.inputDark : ""}
//                     />
//                   </div>

//                   <div
//                     style={{ cursor: "not-allowed" }}
//                     className={styles.formGroup}
//                   >
//                     <label className={mode ? styles.labelDark : ""}>
//                       Production Line Id
//                     </label>
//                     <input
//                       style={{ cursor: "not-allowed" }}
//                       type="text"
//                       value={form.pLId}
//                       disabled
//                       placeholder="It's auto generated"
//                       className={mode ? styles.inputDark : ""}
//                     />
//                   </div>
//                 </div>
//                 <div className={styles.formRow}>
//                   <div className={styles.formGroup}>
//                     <label className={mode ? styles.labelDark : ""}>
//                       Warehouse
//                     </label>

//                     <select
//                       value={form.warehouse}
//                       onChange={(e) => {
//                         handleFormChange("warehouse", e.target.value);
//                         setSelectedItems([]);
//                       }}
//                       className={mode ? styles.inputDark : ""}
//                     >
//                       <option value="">Select Warehouse</option>
//                       {warehouses.map((w) => (
//                         <option key={w.value} value={w.value}>
//                           {w.label}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div className={styles.formGroup}>
//                     <label className={mode ? styles.labelDark : ""}>
//                       Model No
//                     </label>
//                     <input
//                       type="text"
//                       value={form.modelNo}
//                       onChange={(e) =>
//                         handleFormChange("modelNo", e.target.value)
//                       }
//                       placeholder="Enter model no"
//                       className={mode ? styles.inputDark : ""}
//                     />
//                   </div>
//                 </div>
//                 <div className={styles.formRow}>
//                   <div className={styles.formGroup}>
//                     <label className={mode ? styles.labelDark : ""}>
//                       Capacity (pcs/day)
//                     </label>
//                     <input
//                       type="number"
//                       value={form.capacity}
//                       onChange={(e) =>
//                         handleFormChange("capacity", e.target.value)
//                       }
//                       placeholder="Enter Capacity"
//                       className={mode ? styles.inputDark : ""}
//                     />
//                   </div>
//                   <div className={styles.formGroup}>
//                     <label className={mode ? styles.labelDark : ""}>
//                       Working Hours / Day
//                     </label>
//                     <input
//                       type="number"
//                       value={form.workingHrs}
//                       onChange={(e) =>
//                         handleFormChange("workingHrs", e.target.value)
//                       }
//                       placeholder="Enter working hour"
//                       className={mode ? styles.inputDark : ""}
//                     />
//                   </div>
//                 </div>

//                 <ItemChipSearch
//                   mode={mode}
//                   selectedItems={selectedItems}
//                   onAdd={handleAddItem}
//                   onRemove={handleRemoveItem}
//                   warehouseId={form.warehouse}
//                   managerId={managerId}
//                 />

//                 <div className={styles.formGroup}>
//                   <label className={mode ? styles.labelDark : ""}>Status</label>
//                   <select
//                     value={form.status}
//                     onChange={(e) => handleFormChange("status", e.target.value)}
//                     className={mode ? styles.inputDark : ""}
//                   >
//                     <option>Running</option>
//                     <option>Maintenance</option>
//                     <option>Stopped</option>
//                   </select>
//                 </div>

//                 <div
//                   className={styles.formGroup}
//                   style={{ height: "30px" }}
//                 ></div>

//                 {/* <div
//                   className={`${styles.settingsBox} ${mode ? styles.settingsBoxDark : ""}`}
//                 >
//                   <p
//                     className={`${styles.settingsTitle} ${mode ? styles.settingsTitleDark : ""}`}
//                   >
//                     Settings
//                   </p>
//                   <div className={styles.settingRow}>
//                     <span
//                       className={`${styles.settingLabel} ${mode ? styles.settingLabelDark : ""}`}
//                     >
//                       Auto-assign selected products to this line
//                     </span>
//                     <label className={styles.toggle}>
//                       <input
//                         type="checkbox"
//                         checked={form.autoAssignProduct}
//                         onChange={(e) =>
//                           handleFormChange(
//                             "autoAssignProduct",
//                             e.target.checked,
//                           )
//                         }
//                       />
//                       <span className={styles.toggleSlider} />
//                     </label>
//                   </div>
//                 </div> */}
//               </div>
//             )}

//             <div
//               className={`${styles.drawerFooter} ${mode ? styles.drawerFooterDark : ""}`}
//             >
//               <Button
//                 buttonTextColor={"#ffffff"}
//                 buttonBgColor={"#000000"}
//                 buttonClick={() => setShowDrawer(false)}
//                 buttonText={"Cancel"}
//               />
//               <Button
//                 buttonTextColor={"#ffffff"}
//                 buttonBgColor={"#4164E3"}
//                 buttonText={selectedLine ? "Update Line" : "Create Line"}
//                 // buttonClick={() => {
//                 //   if (selectedLine) {
//                 //     handleUpdate();
//                 //   } else {
//                 //     handleCreate();
//                 //   }
//                 // }}
//                 buttonClick={() => {
//                   if (selectedLine) {
//                     handleShowModalContent(selectedLine, "update");
//                   } else {
//                     handleShowModalContent(selectedLine, "create");
//                   }
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Page Shell ─────────────────────────────────────── */}
//       <div
//         className={styles.mgx}
//         style={
//           mode ? { backgroundColor: "#2C2E33", borderColor: "#2C2E33" } : {}
//         }
//       >
//         <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
//           {modalContent}
//         </ModalWrapper>

//         <div className={styles.mgx_top}>
//           <TopTabBar text={"Production/Manage Production Line"} />
//           <div className={styles.mgx_top_right}>
//             <Button
//               buttonIcon={<TestTopAddDealerIcon />}
//               buttonText={"Add Line"}
//               buttonBgColor={"#4164E3"}
//               buttonTextColor={"#ffffff"}
//               buttonBorder={"none"}
//               buttonClick={openCreate}
//             />
//           </div>
//         </div>

//         <div
//           className={styles.mgx_middle}
//           style={
//             mode ? { backgroundColor: "#232529", borderColor: "#232529" } : {}
//           }
//         >
//           {lineStatusData.map((status) => (
//             <div
//               key={status.statusText}
//               className={`${styles.receipts_filter} ${mode ? styles.receipts_filter_dark : ""} ${status.statusText === Isstatus ? (mode ? styles.receipts_filter_active_dark : styles.receipts_filter_active) : ""}`}
//               onClick={() => handleStatusChange(status.statusText)}
//             >
//               <DealerStatusCard
//                 statusText={status.statusText}
//                 statusItemCount={status.statusItemCount}
//               />
//             </div>
//           ))}
//         </div>

//         <div
//           className={styles.mgx_bottom}
//           style={mode ? { backgroundColor: "#2C2E33" } : {}}
//         >
//           <div className={styles.mgx_top} style={{ marginBottom: "10px" }}>
//             <SearchBar
//               padding={"6px"}
//               fontSize={"12px"}
//               fontWeight={"400"}
//               borderRadius={"5px"}
//               placeholder={"Search Production Lines"}
//               onChange={(e) => {
//                 setSearch(e.target.value);
//               }}
//             />
//             {isSuperAdmin && (
//               <div className={styles.mgx_top_right}>
//                 <DropDown
//                   label={"Warehouse"}
//                   listLabel={"All"}
//                   options={[{ label: "All", value: "All" }, ...warehouses]}
//                   onSelect={(option) => {
//                     setSelectedWarehouse(option.value);
//                     setPage(1);
//                   }}
//                 />
//               </div>
//             )}
//           </div>

//           {loading ? (
//             <div className={styles.maindivscroll}>
//               <div
//                 className={styles.mgx_data}
//                 style={mode ? { backgroundColor: "#2C2E33" } : {}}
//               >
//                 {Array.from({ length: 36 }).map((_, i) => (
//                   <SkeletonCard key={`skeleton-${i}`} mode={mode} />
//                 ))}
//               </div>
//             </div>
//           ) : lines.length === 0 ? (
//             <div
//               style={{
//                 flex: 1,
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <NoDataFound
//                 icon={<TemplateNotFound />}
//                 to={"/production/line"}
//               />
//               <p style={{ color: mode ? "#ffffff" : "#000000" }}>
//                 No Data Found
//               </p>
//             </div>
//           ) : (
//             <div className={styles.maindivscroll}>
//               <div
//                 className={styles.mgx_data}
//                 style={mode ? { backgroundColor: "#2C2E33" } : {}}
//               >
//                 {lines.map((line) => (
//                   <div
//                     className={styles.mgx_card}
//                     key={line.pLId}
//                     onClick={() => openEdit(line)}
//                   >
//                     <ProdLineInfoCard
//                       lineName={line.name}
//                       lineStatus={line.status}
//                       capacity={line.capacity}
//                       workingHrs={line.workingHrs}
//                       warehouse={line.warehouse}
//                       warehouseId={line.warehouseId}
//                       // manufacturer={line.items}
//                       deleteIconTime={line.createdAt}
//                       pLId={line.pLId}
//                       modelNo={line.modelNo}
//                       // onDelete={() => handleDeleteLine(line)}
//                       onDelete={() => handleShowModalContent(line, "delete")}
//                     />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>

//         <div
//           className={styles.mgx_pagination}
//           style={{ backgroundColor: mode ? "#232529" : "#fff" }}
//         >
//           <div style={{ width: "50%" }}>
//             <div
//               style={{
//                 width: "50%",
//                 display: "flex",
//                 justifyContent: "flex-start",
//                 fontSize: "14px",
//               }}
//             >
//               <GoToPage
//                 currentPage={page}
//                 setCurrentPage={(n) => setPage(n)}
//                 totalPages={totalPages}
//                 key="goto"
//               />
//             </div>
//           </div>
//           <div
//             style={{
//               width: "50%",
//               display: "flex",
//               justifyContent: "flex-end",
//               fontSize: "12px",
//             }}
//           >
//             <Pagenation
//               currentPage={page}
//               setCurrentPage={(n) => setPage(n)}
//               totalPages={totalPages}
//               key="page"
//             />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ManageProductionLine;

// ------------------------------- Update for multiple Select ------------------------

import React, { useEffect, useState } from "react";
import styles from "./ManageProductionLine.module.css";
import { useAuth } from "../../components/context/Auth";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import Button from "../../components/updatedComponents/Dealers/Button";
import { TestTopAddDealerIcon } from "../../components/icons/Icon";
import DealerStatusCard from "../../components/updatedComponents/Dealers/DealerStatusCard";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import { TemplateNotFound } from "../../components/icons/Icon2";
import GoToPage from "../../components/updatedComponents/Pagnation/GoToPage";
import Pagenation from "../../components/updatedComponents/Pagnation/Pagenation";
import ProdLineInfoCard from "../../components/updatedComponents/Production/ManageProduction/ProdLineInfoCard";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import fetchData from "../../APIsControll/apiControll";
import { ItemChipSearch } from "../../components/updatedComponents/Production/ManageProduction/ItemChipSearch";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import { SkeletonCard } from "../../components/updatedComponents/Production/ManageProduction/SkeletonCard";
import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";

const STATUS_FILTERS = ["All", "Running", "Maintenance", "Stopped"];

const EMPTY_FORM = {
  name: "",
  pLId: "",
  modelNo: "",
  warehouse: "",
  warehouseId: "",
  capacity: "",
  workingHrs: "",
  status: "Stopped",
  autoAssignProduct: false,
};

// Two items are the same if both itemNo and warehouseId match
const sameItem = (a, b) =>
  a.itemNo === b.itemNo && a.warehouseId === b.warehouseId;

const toObjs = (arr) => arr.map((itemNo) => ({ itemNo }));

const ManageProductionLine = () => {
  const { mode, managerId, designations } = useAuth();
  const { show } = useToast();

  const [Isstatus, setIsstatus] = useState("All");
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedLine, setSelectedLine] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [warehouses, setWarehouses] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [originalItems, setOriginalItems] = useState([]); // items as loaded from server (update only)
  const [selectedWarehouse, setSelectedWarehouse] = useState("All");
  const [lines, setLines] = useState([]);
  const [statusCounts, setStatusCounts] = useState([]);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const isSuperAdmin = designations.includes("superadmin");

  const resetDrawerState = () => {
    setForm(EMPTY_FORM);
    setSelectedItems([]);
    setOriginalItems([]);
    setSelectedLine(null);
  };

  const closeDrawer = () => {
    setShowDrawer(false);
    resetDrawerState();
  };

  const openEdit = async (line) => {
    setSelectedLine(line);
    setShowDrawer(true);
    setDrawerLoading(true);

    try {
      const payload = {
        managerId: managerId,
        pLId: line.pLId,
      };
      const res = await fetchData(`production/productionLine`, payload);

      if (res?.status === "success" && res.data) {
        const m = res.data;

        const loaded = (m.items || []).map((i) => ({
          itemNo: i.itemNo,
          warehouseId: m.warehouseId,
        }));
        setSelectedItems(loaded);
        setOriginalItems(loaded);

        setForm({
          name: m.name,
          pLId: m.pLId || "",
          modelNo: m.modelNumber || "",
          warehouse: m.warehouseId,
          capacity: m.capacity,
          workingHrs: m.workingHrs,
          status: m.status ? m.status : "Stopped",
          autoAssignProduct: m.autoAssignProduct,
        });

        setSelectedLine((prev) => ({ ...prev, ...m }));
      } else {
        show(res?.msg || "Failed to load production line details", "error");
        closeDrawer();
      }
    } catch (error) {
      show("Failed to load production line details", "error");
      closeDrawer();
    } finally {
      setDrawerLoading(false);
    }
  };

  const handleDeleteLine = async (line) => {
    try {
      const payload = { managerId, pLId: line.pLId };
      const result = await fetchData(`production/delproductionLine`, payload);
      if (result?.status === "success") {
        show(result?.msg || "Deleted");
        fetchLines();
      } else {
        show(result?.msg, "error");
      }
    } catch (error) {
      show("Failed to delete production line", "error");
    }
  };

  // useEffect(() => {
  //   const getAllwarehouses = async () => {
  //     try {
  //       const payload = { managerId };
  //       const AllWarehouse = await fetchData(
  //         `warehouses/getAllWarehouseList`,
  //         payload,
  //       );
  //       setWarehouses(
  //         (AllWarehouse?.data || []).map((w) => ({
  //           label: w.warehousename,
  //           value: w.warehouseId,
  //         })),
  //       );
  //     } catch (error) {
  //       show("Failed to load warehouses", "error");
  //     }
  //   };
  //   getAllwarehouses();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [managerId]);

  // Debounce free-text search so we don't hit the API on every keystroke

  useEffect(() => {
    const getAllwarehouses = async () => {
      try {
        let warehouseList = [];

        if (isSuperAdmin) {
          const payload = { managerId };

          const AllWarehouse = await fetchData(
            "warehouses/getAllWarehouseList",
            payload,
          );

          warehouseList = AllWarehouse?.data || [];
        } else {
          const result = await fetchData("managers/managerProfile", {
            loginId: localStorage.getItem("loginID"),
          });

          warehouseList = result?.data?.selectedWarehouse || [];
        }

        setWarehouses(
          warehouseList.map((w) => ({
            label: w.warehousename,
            value: w.warehouseId,
          })),
        );
      } catch (error) {
        show("Failed to load warehouses", "error");
      }
    };

    getAllwarehouses();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managerId, isSuperAdmin]);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(search), 400);
    return () => clearTimeout(t);
  }, [search]);

  // Reset to page 1 whenever a filter changes (status / warehouse / search)
  useEffect(() => {
    setPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Isstatus, selectedWarehouse, debouncedSearch]);

  const fetchLines = async () => {
    setLoading(true);
    try {
      const payload = {
        managerId: managerId,
        status: Isstatus === "All" ? "" : Isstatus,
        warehouseId: selectedWarehouse === "All" ? "" : selectedWarehouse,
        keyword: debouncedSearch,
      };
      const res = await fetchData(
        `production/productionLines?page=${page}`,
        payload,
      );

      if (res?.status === "success") {
        setLines(
          (res.data || []).map((m) => ({
            id: m.pLId,
            pLId: m.pLId,
            name: m.name,
            modelNumber: m.modelNumber || "",
            warehouse: m.warehouse,
            warehouseId: m.warehouseId,
            capacity: m.capacity,
            workingHrs: m.workingHrs,
            status: m.status || "",
            items: m.items || [],
            createdAt: m.createdAt,
          })),
        );
        setStatusCounts(res.prodLines || []);
        setTotalPages(res.pages || 1);
      } else {
        setLines([]);
        setStatusCounts([]);
        setTotalPages(1);
      }
    } catch (error) {
      show("Failed to load production lines", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLines();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managerId, page, Isstatus, selectedWarehouse, debouncedSearch]);

  const lineStatusData = STATUS_FILTERS.map((s) => {
    const match = statusCounts.find(
      (c) => c.status?.toLowerCase() === s.toLowerCase(),
    );
    return {
      statusText: s,
      statusItemCount: match ? match.count : 0,
    };
  });

  const openCreate = () => {
    resetDrawerState();
    setShowDrawer(true);
  };

  const handleFormChange = (field, value) =>
    setForm((prev) => ({ ...prev, [field]: value }));

  const handleStatusChange = (s) => {
    setIsstatus(s);
    setPage(1);
  };

  // Add if missing, remove if present (used by search dropdown and chip ×)
  const handleToggleItem = (item) =>
    setSelectedItems((prev) =>
      prev.some((p) => sameItem(p, item))
        ? prev.filter((p) => !sameItem(p, item))
        : [...prev, item],
    );

  // Same payload for create and update.
  // On update it also sends oldItems / newItems / addedItems / removedItems.
  // Keep only the fields your backend reads.
  const buildPayload = () => {
    const isUpdate = !!selectedLine?.pLId;
    const oldNos = originalItems.map((i) => i.itemNo);
    const newNos = selectedItems.map((i) => i.itemNo);

    return {
      managerId,
      ...(isUpdate && { pLId: selectedLine.pLId }),
      name: form.name.trim(),
      modelNumber: form.modelNo.trim(),
      status: form.status,
      capacity: Number(form.capacity),
      workingHrs: Number(form.workingHrs),
      warehouse:
        warehouses.find((w) => w.value === form.warehouse)?.label || "",
      warehouseId: form.warehouse,
      autoAssignProduct: form.autoAssignProduct,
      selectedItems: toObjs(newNos), // final list (create + update)
      ...(isUpdate && {
        oldItems: toObjs(oldNos),
        newItems: toObjs(newNos),
        addedItems: toObjs(newNos.filter((n) => !oldNos.includes(n))),
        removedItems: toObjs(oldNos.filter((n) => !newNos.includes(n))),
      }),
    };
  };

  const handleSave = async () => {
    try {
      const result = await fetchData(
        `production/addUpProductionLine`,
        buildPayload(),
      );

      if (result?.status === "success") {
        show(result?.msg);
        closeDrawer();
        fetchLines();
      } else {
        show(result?.msg, "error");
      }
    } catch (error) {
      show("Something went wrong", "error");
    }
  };

  const handleOpenModal = (content) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const validateForm = () => {
    if (!form.name.trim()) {
      show("Production Line Name is required.", "error");
      return false;
    }

    if (!form.warehouse) {
      show("Please select a warehouse.", "error");
      return false;
    }

    if (!form.modelNo.trim()) {
      show("Model No is required.", "error");
      return false;
    }

    if (!form.capacity) {
      show("Capacity is required.", "error");
      return false;
    }

    if (!form.workingHrs) {
      show("Working Hours is required.", "error");
      return false;
    }

    if (!form.status) {
      show("Status is required.", "error");
      return false;
    }

    if (selectedItems.length === 0) {
      show("Please select at least one item.", "error");
      return false;
    }

    return true;
  };

  const handleShowModalContent = (line, text) => {
    if (text === "create" || text === "update") {
      if (!validateForm()) return;
    }
    handleOpenModal(
      <ManagerModal
        heading={`${text.charAt(0).toUpperCase() + text.slice(1)} Production Line`}
        centerHeading={`Are you sure you want to ${text} Production Line`}
        subHeading={`To confirm, type ${text}`}
        targetWord={text}
        handleSubmit={
          text === "delete" ? () => handleDeleteLine(line) : handleSave
        }
        handleCloseModal={() => setIsModalOpen(false)}
        focus={true}
      />,
    );
  };

  return (
    <>
      {/* ── Centered Modal ──────────────────────────────────── */}
      {showDrawer && (
        <div className={styles.modalOverlay} onClick={closeDrawer}>
          <div
            className={`${styles.centeredModal} ${mode ? styles.centeredModalDark : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className={styles.drawerHeader}>
              <h2>
                {selectedLine
                  ? "Update Production Line"
                  : "Add Production Line"}
              </h2>
              <button onClick={closeDrawer}>✕</button>
            </div>

            {/* Body */}
            {drawerLoading ? (
              <div style={{ padding: "40px", textAlign: "center" }}>
                Loading...
              </div>
            ) : (
              <div className={styles.drawerBody}>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={mode ? styles.labelDark : ""}>
                      Production Line Name
                    </label>
                    <input
                      type="text"
                      value={form.name}
                      onChange={(e) => handleFormChange("name", e.target.value)}
                      placeholder="Enter line name"
                      className={mode ? styles.inputDark : ""}
                    />
                  </div>

                  <div
                    style={{ cursor: "not-allowed" }}
                    className={styles.formGroup}
                  >
                    <label className={mode ? styles.labelDark : ""}>
                      Production Line Id
                    </label>
                    <input
                      style={{ cursor: "not-allowed" }}
                      type="text"
                      value={form.pLId}
                      disabled
                      placeholder="It's auto generated"
                      className={mode ? styles.inputDark : ""}
                    />
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={mode ? styles.labelDark : ""}>
                      Warehouse
                    </label>

                    <select
                      value={form.warehouse}
                      onChange={(e) => {
                        handleFormChange("warehouse", e.target.value);
                        setSelectedItems([]);
                      }}
                      className={mode ? styles.inputDark : ""}
                    >
                      <option value="">Select Warehouse</option>
                      {warehouses.map((w) => (
                        <option key={w.value} value={w.value}>
                          {w.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className={styles.formGroup}>
                    <label className={mode ? styles.labelDark : ""}>
                      Model No
                    </label>
                    <input
                      type="text"
                      value={form.modelNo}
                      onChange={(e) =>
                        handleFormChange("modelNo", e.target.value)
                      }
                      placeholder="Enter model no"
                      className={mode ? styles.inputDark : ""}
                    />
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={mode ? styles.labelDark : ""}>
                      Capacity (pcs/day)
                    </label>
                    <input
                      type="number"
                      value={form.capacity}
                      onChange={(e) =>
                        handleFormChange("capacity", e.target.value)
                      }
                      placeholder="Enter Capacity"
                      className={mode ? styles.inputDark : ""}
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={mode ? styles.labelDark : ""}>
                      Working Hours / Day
                    </label>
                    <input
                      type="number"
                      value={form.workingHrs}
                      onChange={(e) =>
                        handleFormChange("workingHrs", e.target.value)
                      }
                      placeholder="Enter working hour"
                      className={mode ? styles.inputDark : ""}
                    />
                  </div>
                </div>

                <ItemChipSearch
                  mode={mode}
                  selectedItems={selectedItems}
                  onToggle={handleToggleItem}
                  onRemove={handleToggleItem}
                  warehouseId={form.warehouse}
                  managerId={managerId}
                />

                <div className={styles.formGroup}>
                  <label className={mode ? styles.labelDark : ""}>Status</label>
                  <select
                    value={form.status}
                    onChange={(e) => handleFormChange("status", e.target.value)}
                    className={mode ? styles.inputDark : ""}
                  >
                    <option>Running</option>
                    <option>Maintenance</option>
                    <option>Stopped</option>
                  </select>
                </div>

                <div
                  className={styles.formGroup}
                  style={{ height: "30px" }}
                ></div>

                {/* <div
                  className={`${styles.settingsBox} ${mode ? styles.settingsBoxDark : ""}`}
                >
                  <p
                    className={`${styles.settingsTitle} ${mode ? styles.settingsTitleDark : ""}`}
                  >
                    Settings
                  </p>
                  <div className={styles.settingRow}>
                    <span
                      className={`${styles.settingLabel} ${mode ? styles.settingLabelDark : ""}`}
                    >
                      Auto-assign selected products to this line
                    </span>
                    <label className={styles.toggle}>
                      <input
                        type="checkbox"
                        checked={form.autoAssignProduct}
                        onChange={(e) =>
                          handleFormChange(
                            "autoAssignProduct",
                            e.target.checked,
                          )
                        }
                      />
                      <span className={styles.toggleSlider} />
                    </label>
                  </div>
                </div> */}
              </div>
            )}

            <div
              className={`${styles.drawerFooter} ${mode ? styles.drawerFooterDark : ""}`}
            >
              <Button
                buttonTextColor={"#ffffff"}
                buttonBgColor={"#000000"}
                buttonClick={closeDrawer}
                buttonText={"Cancel"}
              />
              <Button
                buttonTextColor={"#ffffff"}
                buttonBgColor={"#4164E3"}
                buttonText={selectedLine ? "Update Line" : "Create Line"}
                buttonClick={() =>
                  handleShowModalContent(
                    selectedLine,
                    selectedLine ? "update" : "create",
                  )
                }
              />
            </div>
          </div>
        </div>
      )}

      {/* ── Page Shell ─────────────────────────────────────── */}
      <div
        className={styles.mgx}
        style={
          mode ? { backgroundColor: "#2C2E33", borderColor: "#2C2E33" } : {}
        }
      >
        <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
          {modalContent}
        </ModalWrapper>

        <div className={styles.mgx_top}>
          <TopTabBar text={"Production/Manage Production Line"} />
          <div className={styles.mgx_top_right}>
            <Button
              buttonIcon={<TestTopAddDealerIcon />}
              buttonText={"Add Line"}
              buttonBgColor={"#4164E3"}
              buttonTextColor={"#ffffff"}
              buttonBorder={"none"}
              buttonClick={openCreate}
            />
          </div>
        </div>

        <div
          className={styles.mgx_middle}
          style={
            mode ? { backgroundColor: "#232529", borderColor: "#232529" } : {}
          }
        >
          {lineStatusData.map((status) => (
            <div
              key={status.statusText}
              className={`${styles.receipts_filter} ${mode ? styles.receipts_filter_dark : ""} ${status.statusText === Isstatus ? (mode ? styles.receipts_filter_active_dark : styles.receipts_filter_active) : ""}`}
              onClick={() => handleStatusChange(status.statusText)}
            >
              <DealerStatusCard
                statusText={status.statusText}
                statusItemCount={status.statusItemCount}
              />
            </div>
          ))}
        </div>

        <div
          className={styles.mgx_bottom}
          style={mode ? { backgroundColor: "#2C2E33" } : {}}
        >
          <div className={styles.mgx_top} style={{ marginBottom: "10px" }}>
            <SearchBar
              padding={"6px"}
              fontSize={"12px"}
              fontWeight={"400"}
              borderRadius={"5px"}
              placeholder={"Search Production Lines"}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
            {isSuperAdmin && (
              <div className={styles.mgx_top_right}>
                <DropDown
                  label={"Warehouse"}
                  listLabel={"All"}
                  options={[{ label: "All", value: "All" }, ...warehouses]}
                  onSelect={(option) => {
                    setSelectedWarehouse(option.value);
                    setPage(1);
                  }}
                />
              </div>
            )}
          </div>

          {loading ? (
            <div className={styles.maindivscroll}>
              <div
                className={styles.mgx_data}
                style={mode ? { backgroundColor: "#2C2E33" } : {}}
              >
                {Array.from({ length: 36 }).map((_, i) => (
                  <SkeletonCard key={`skeleton-${i}`} mode={mode} />
                ))}
              </div>
            </div>
          ) : lines.length === 0 ? (
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <NoDataFound
                icon={<TemplateNotFound />}
                to={"/production/line"}
              />
              <p style={{ color: mode ? "#ffffff" : "#000000" }}>
                No Data Found
              </p>
            </div>
          ) : (
            <div className={styles.maindivscroll}>
              <div
                className={styles.mgx_data}
                style={mode ? { backgroundColor: "#2C2E33" } : {}}
              >
                {lines.map((line) => (
                  <div
                    className={styles.mgx_card}
                    key={line.pLId}
                    onClick={() => openEdit(line)}
                  >
                    <ProdLineInfoCard
                      lineName={line.name}
                      lineStatus={line.status}
                      capacity={line.capacity}
                      workingHrs={line.workingHrs}
                      warehouse={line.warehouse}
                      warehouseId={line.warehouseId}
                      // manufacturer={line.items}
                      deleteIconTime={line.createdAt}
                      pLId={line.pLId}
                      modelNo={line.modelNumber}
                      onDelete={() => handleShowModalContent(line, "delete")}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div
          className={styles.mgx_pagination}
          style={{ backgroundColor: mode ? "#232529" : "#fff" }}
        >
          <div style={{ width: "50%" }}>
            <div
              style={{
                width: "50%",
                display: "flex",
                justifyContent: "flex-start",
                fontSize: "14px",
              }}
            >
              <GoToPage
                currentPage={page}
                setCurrentPage={(n) => setPage(n)}
                totalPages={totalPages}
                key="goto"
              />
            </div>
          </div>
          <div
            style={{
              width: "50%",
              display: "flex",
              justifyContent: "flex-end",
              fontSize: "12px",
            }}
          >
            <Pagenation
              currentPage={page}
              setCurrentPage={(n) => setPage(n)}
              totalPages={totalPages}
              key="page"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageProductionLine;
